import {
    CALCULATOR_KEYS,
    CalculatorConfig,
    getCalculatorConfig
} from "@omni/services/tracking/trackers/tools/calculators/config";
import * as ToolsStepTracker from "@omni/services/tracking/trackers/tools/toolStep.tracker";

export const trackStart = (calculatorKey: CALCULATOR_KEYS) => {
    if (!calculatorKey) return;

    const config: CalculatorConfig = getCalculatorConfig(calculatorKey);

    ToolsStepTracker.track(config.start, config.context);
};

export const trackSubmit = (calculatorKey: CALCULATOR_KEYS) => {
    if (!calculatorKey) return;

    const config: CalculatorConfig = getCalculatorConfig(calculatorKey);

    ToolsStepTracker.trackSubmit(config.submit, config.context);
};
